/**
 * useTransport - Hook for audio transport controls (play/stop/bpm)
 */

import { transportService } from '@/runtime/web';

export function useTransport() {
  return {
    play: () => transportService.play(),
    pause: () => transportService.pause(),
    stop: () => transportService.stop(),
    setBpm: (bpm: number) => transportService.setBpm(bpm),
    getState: () => transportService.getState(),
    getTime: () => transportService.getTime()
  };
}
